import React from 'react';
import { Input as AntInput } from 'antd';
import type { InputProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Input (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-input` class hook.
 */
export const Input = ({ className, ...props }: InputProps) => (
  <AntInput {...props} className={clsx('wk-input', className)} />
);

Input.TextArea = AntInput.TextArea;
Input.Search = AntInput.Search;
Input.Password = AntInput.Password;
Input.Group = AntInput.Group;
